import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup, FormControl, FormArray } from '@angular/forms';
import { GridDataResult, PageChangeEvent, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { State, process, orderBy } from "@progress/kendo-data-query";
import { tap } from 'rxjs/operators';
import { IProduct, IProductAttribute, IProductCategory, ProductAttribute } from 'src/app/core/models';
import { ProductAttributeService } from 'src/app/core/services/product-attribute.service';
import { NotifyType } from '../../../../core/enums/NotifyType';
import { IInfo, Info } from '../../../../core/common';

import { Subject } from 'rxjs';
import { AppNotifyService } from '../../../../core/services/app-notify.service';
@Component({
  selector: 'app-manage-attribute',
  templateUrl: './manage-attribute.component.html',
  styleUrls: ['./manage-attribute.component.scss']
})
export class ManageAttributeComponent implements OnInit {
  //#region constructor ngOnInit Members
  public actionType: string;
  attributeForm: FormGroup;
  public attributeNameInfo: string;
  public showAttributeInfoPopup: boolean = false;
  public showAttributeInfoIcon: boolean;

  public inProgressMessage: boolean;
  public successMessage: boolean;
  public errorMessage: boolean;
  public saveInProcess: boolean;
  public infoMessage: Info = new Info();
  attributeValues: FormArray;

  constructor(private productAttributeService: ProductAttributeService, private formBuilder: FormBuilder,
    private appNotifyService: AppNotifyService,

  ) { }

  ngOnInit(): void {
    this.attributeForm = this.createAttributeForm();

    this.productAttributeService.getAll().subscribe((productAttributes) => {
      this.loadAttributeGrid()
    })
    this.showAttributeInfoIcon = false;      //Need to put this code under attribute name condition
    this.attributeNameInfo = 'Attribute name is not available';
  }
  createAttributeForm() {
    return this.formBuilder.group({
      attributeId: [""],
      attributeName: [""],
      publishedName: [""],
      v6OptionCode: [""],
      attributeValueTypeId: [""],
      isActive: [false],
      attributeValues: this.formBuilder.array([])
    });
  }
  //#endregion

  //#region Attribute name 

  protected attributeNameShouldbeUnique() {
    let existingAttributeId = null;
    if (this.attributeEditDialog.editAttributeData) {
      if ((this.attributeEditDialog.editAttributeData as ProductAttribute).attributeId) {
        existingAttributeId = (this.attributeEditDialog.editAttributeData as ProductAttribute).attributeId;
        this.attributeEditDialog.isEdit = true
      } else {
        this.attributeEditDialog.isEdit = false;
        this.attributeEditDialog.editAttributeData = null;
      }
    } else {
      this.attributeEditDialog.isEdit = false;
      this.attributeEditDialog.editAttributeData = null;
    }
    const attributeNameValue = this.attributeForm.controls.attributeName.value as string;
    if (this.attributeEditDialog.isEdit) {
      if (attributeNameValue) {

        const hasValue = this.productAttributeService.productAttributes
          .filter((attributes) => attributes.attributeId != existingAttributeId)
          .find(r => r.attributeName.toLowerCase() === attributeNameValue.toLowerCase());
        if (hasValue) {
          this.attributeEditDialog.isInvalidAttributeNameMessge = true;
          this.attributeEditDialog.isInvalidAttributeName = true;
        } else {
          this.attributeEditDialog.isInvalidAttributeNameMessge = false;
          this.attributeEditDialog.isInvalidAttributeName = false;

        }
      } else {
        this.attributeEditDialog.isInvalidAttributeNameMessge = false;
        this.attributeEditDialog.isInvalidAttributeName = false;

      }

    } else {

      if (attributeNameValue) {

        const hasValue = this.productAttributeService.productAttributes
          .find(r => r.attributeName.toLowerCase() === attributeNameValue.toLowerCase());
        if (hasValue) {
          this.attributeEditDialog.isInvalidAttributeNameMessge = true;
          this.attributeEditDialog.isInvalidAttributeName = true;

        } else {
          this.attributeEditDialog.isInvalidAttributeNameMessge = false;
          this.attributeEditDialog.isInvalidAttributeName = false;

        }
      } else {
        this.attributeEditDialog.isInvalidAttributeNameMessge = false;
        this.attributeEditDialog.isInvalidAttributeName = false;

      }
    }
    this.validateAttributeForm();
  }

  //#endregion
  //#region Grid Function & Operations
  protected loadAttributeGrid() {
    //get data from service
    const data = this.productAttributeService.productAttributes;
    this.manageAttributeGridView = process(data, this.gridState);
  }
  protected manageAttributeGridView: GridDataResult;
  protected manageAttribute = {
    grid: {
      loading: false,
      pageSize: 10,
      buttonCount: 5,
      pageSizes: [50, 75, 100],
      currentPage: 0,
      idLbl: "ID",
      v6ReferenceCodeLbl: "V6 Reference Code",
      nameLbl: "Name",
      publishedNameLbl: "Published Name",
      typeLbl: "Type",

    }
  };


  protected gridState: State = {
    sort: [],
    skip: 0,
    take: 10,
    group: [],
    filter: null,
  };
  //#endregion
  //#region sorting,filtering,pagination of grid
  protected attributeGridSortChange(sort): void {
    this.gridState.sort = sort;
    this.loadAttributeGrid();
  }
  protected attributeGridPageChange({ skip, take }: PageChangeEvent): void {
    this.gridState.skip = skip;
    this.gridState.take = take;
    this.loadAttributeGrid();

  }
  public gridDataStateChange(state: DataStateChangeEvent): void {
    this.gridState = state;
    this.loadAttributeGrid();
  }

  //#endregion
  createItem(){
    return this.formBuilder.group({
      displaySequence: [0],
      attributeValueName: [''],
      v6Code: [''],
      v6OptionCode: [''],
      attributeValueDescription: [''],
      attributeValueId: [0],
      attributeId: [0],
      isActive: [true]
    })
  }
  //#region Edit Dialog
  protected get f() {
    return this.attributeForm.controls;
  }
  protected attributeEditDialog = {
    typeDataLoading: false,
    opened: false,
    nameLbl: "Name",
    publishedNameLbl: "Published Name",
    idLbl: "ID",
    v6ReferenceCodeLbl: "V6 Reference Code",
    active: "Active",
    typeLbl: "Type",
    typeData: [{ name: 'List', value: 1 },
    { name: 'Boolean', value: 2 },
    { name: 'Radio', value: 3 },
    { name: 'Text', value: 4 },],  //Needs to bind dynamic
    typedefaultItemData: {},
    editAttributeData: null,
    isEdit: false,
    isInvalidAttributeName: false,
    isInvalidAttributeNameMessge: false,
    isInvalidPublishedName: false,
    isInvalidV6OptionCode: false,
    isInvalidAttributeValueTypeId: false,
    isInvalidIsActive: false,
    isSubmitted: false,
    isValidForm: this.validateAttributeForm()
  };

  protected validateAttributeForm(): boolean {

    let isValid = true;
    if (!this.attributeEditDialog) {
      return;
    }
    if (this.attributeEditDialog.isSubmitted) {
      if (this.f.attributeName.value) {
        if (this.attributeEditDialog.isInvalidAttributeNameMessge) {
          this.attributeEditDialog.isInvalidAttributeName = true;
          this.attributeEditDialog.isInvalidAttributeNameMessge = true;
          isValid = false;
        } else {
          this.attributeEditDialog.isInvalidAttributeName = false;
          this.attributeEditDialog.isInvalidAttributeNameMessge = false;
        }

      } else {
        this.attributeEditDialog.isInvalidAttributeName = true;
        isValid = false;
      }

      if (this.f.publishedName.value) {
        this.attributeEditDialog.isInvalidPublishedName = false;
      } else {
        this.attributeEditDialog.isInvalidPublishedName = true;
        isValid = false;
      }

      if (this.f.v6OptionCode.value) {
        this.attributeEditDialog.isInvalidV6OptionCode = false;
      } else {
        this.attributeEditDialog.isInvalidV6OptionCode = true;
        isValid = false;
      }

      if (this.f.attributeValueTypeId.value) {
        this.attributeEditDialog.isInvalidAttributeValueTypeId = false;
      } else {
        this.attributeEditDialog.isInvalidAttributeValueTypeId = true;
        isValid = false;
      }
      if (this.f.isActive.value !== undefined) {
        this.attributeEditDialog.isInvalidIsActive = false;
      } else {
        this.attributeEditDialog.isInvalidIsActive = true;
        isValid = false;
      }

    }
    return isValid;
  }
  protected resetAttributeForm() {
    this.attributeEditDialog.isInvalidAttributeName = false;
    this.attributeEditDialog.isInvalidAttributeNameMessge = false;
    this.attributeEditDialog.isInvalidPublishedName = false;
    this.attributeEditDialog.isInvalidIsActive = false;
    this.attributeEditDialog.isInvalidAttributeValueTypeId = false;
    this.attributeEditDialog.isInvalidV6OptionCode = false;
    this.attributeEditDialog.isSubmitted = false;
    this.attributeForm = this.createAttributeForm();
  }
  public get manageAttributeForm() {
    return this.attributeForm.controls;
  }

  protected toggleAttributeEditDialog(popupLabel, data: IProductAttribute): void {
    (this.attributeForm.get('attributeValues') as FormArray).clear();
    this.attributeEditDialog.editAttributeData = data;
    if(data){
      this.productAttributeService.get(data.attributeId).toPromise().then((prodctAttribute) => {
        (this.attributeForm.get('attributeValues') as FormArray).clear();
        this.attributeEditDialog.editAttributeData=prodctAttribute;
        (this.attributeEditDialog.editAttributeData as IProductAttribute).attributeValues.forEach((attitem,index)=>{
          this.attributeValues = this.attributeForm.get('attributeValues') as FormArray;
          this.attributeValues.push(this.formBuilder.group({
            displaySequence: [attitem.displaySequence],
            attributeValueName: [attitem.attributeValueName],
            attributeValueId: [attitem.attributeValueId],
            attributeId: [attitem.attributeId],
            isActive: [attitem.isActive],
            v6Code: [attitem.v6Code],
            v6OptionCode: [attitem.v6OptionCode],
            attributeValueDescription: [attitem.attributeValueDescription]
          }));
        }) 
      });
    }
   
    //this.inProgressMessage = false;
    //this.successMessage = false;
    //this.errorMessage = false;
    this.infoMessage = new Info();
    this.saveInProcess = false;
    this.resetAttributeForm();
    this.showAttributeInfoIcon = false;
    this.attributeForm.reset();
    this.manageAttributeForm.attributeValueTypeId.setValue("");
    this.attributeEditDialog.opened = !this.attributeEditDialog.opened;
    if (popupLabel == 'Edit') {
      this.manageAttributeForm.attributeId.setValue(data.attributeId);
      this.manageAttributeForm.attributeName.setValue(data.attributeName);
      this.manageAttributeForm.publishedName.setValue(data.publishedName);
      this.manageAttributeForm.v6OptionCode.setValue(data.v6OptionCode);
      this.attributeEditDialog.typeData = this.attributeEditDialog.typeData;
      this.manageAttributeForm.attributeValueTypeId.setValue(data.attributeValueTypeId);
      this.manageAttributeForm.isActive.setValue(data.isActive);
      this.actionType = popupLabel;

     
      
    } else {
      this.actionType = popupLabel;
      this.attributeEditDialog.typeData = this.attributeEditDialog.typeData;
      //call type dropdown binding method here
    }
  }

  


  //#endregion
  //#region Save/update attribute form data
  protected saveAttributeData() {
    this.attributeEditDialog.isSubmitted = true;
    console.log(this.attributeForm.value);
    if (!this.validateAttributeForm()) {
      return;
    }


    this.inProgressMessage = true;
    this.saveInProcess = true;
    this.infoMessage.genericSuccess = "";
    this.infoMessage.genericError = "";
    this.infoMessage.genericInProgress = this.infoMessage.inProgressMessage;
    //call service method here
    if (this.attributeForm.value.isActive == null) {
      this.attributeForm.value.isActive = false;
    }
    console.log(this.attributeForm.value);
    if (this.manageAttributeForm.attributeId.value) { //If Id  is there update it or else save it
      this.productAttributeService.updateProductAttribute(this.attributeForm.value)
        .subscribe((productAttributes: ProductAttribute[]) => {
          console.log(productAttributes);
          this.infoMessage.genericInProgress = "";
          this.saveInProcess = false;
          //this.inProgressMessage = false;
          if (productAttributes.length > 0) {
            this.successMessage = true;
            this.infoMessage.genericSuccess = this.infoMessage.successMessage;

            this.loadAttributeGrid();
          } else {
            //this.errorMessage = true;
            this.infoMessage.genericError = this.infoMessage.errorMessage;

          }

          //this.attributeEditDialog.opened = !this.attributeEditDialog.opened;
        })
    } else {
      this.productAttributeService.addProductAttribute(this.attributeForm.value)
        .subscribe((productAttribute) => {
          //this.inProgressMessage = false;
          this.infoMessage.genericInProgress = "";
          this.saveInProcess = false;
          console.log(productAttribute);
          if (productAttribute) {
            this.infoMessage.genericSuccess = this.infoMessage.successMessage;
            //this.successMessage = true;
            this.loadAttributeGrid();
          } else {
            //this.errorMessage = true;
            this.infoMessage.genericError = this.infoMessage.errorMessage;

          }
          //this.attributeEditDialog.opened = !this.attributeEditDialog.opened;
          this.resetAttributeForm();
        })
    }
    
  }
  addItem() {
    this.attributeValues = this.attributeForm.get('attributeValues') as FormArray;
    this.attributeValues.push(this.createItem());
  }
  removeItem(index) {
    (this.attributeForm.get('attributeValues') as FormArray).removeAt(index);
  }
  //#endregion
  //#region attribute type dropdown change method
  attributeEditDialogSelected(event) {

  }
  //#endregion

  //#region delete item
  public gridItemToRemove: any;
  public removeConfirmationSubject: Subject<boolean> = new Subject<boolean>();

  gridDelete = {
    label: {
      deleteConfirmLbl: 'Are you sure you want to delete attribute ',
      deleteYesLbl: 'Yes',
      deleteNoLbl: 'No',
      confirmLbl: 'Please confirm',
    }
  }


  public removeConfirmation(dataItem): Subject<boolean> {
    this.gridItemToRemove = dataItem; // show delete item confirmation box
    return this.removeConfirmationSubject;
  }

  protected confirmRemove(shouldRemove: boolean): void {
    if (shouldRemove) {
      this.removeConfirmationSubject.next(shouldRemove);
      this.RemoveHandler();
    }
    else {
      this.removeConfirmationSubject.next(shouldRemove);
      this.gridItemToRemove = null;
    }
  }

  protected RemoveHandler() {
    this.productAttributeService.deleteProductAttribute(this.gridItemToRemove).subscribe((isRemoved: boolean) => {
      const attributeId = this.gridItemToRemove.attributeId;
      this.gridItemToRemove = null;
      this.appNotifyService.notify(NotifyType.SUCCESS, "Selected attribute has been removed.");

      if (this.productAttributeService.productAttributes) {
        //This is a Local Remove
        const index = (this.productAttributeService.productAttributes).findIndex(r => r.attributeId === attributeId);
        (this.productAttributeService.productAttributes).splice(index, 1);
        this.loadAttributeGrid();

      }



    }, error => {
      this.appNotifyService.notify(NotifyType.ERROR, 'An Error Occured');
    });
  }

  //#endregion
}
